'use strict';

const swipeObject = {
  dir: null,
  startPosition: 0,
  endPosition: 0
};

export default swipeObject;
